addEventListener('turbo:load', () => {
	for (let ddi of document.querySelectorAll('.dropdown-interactive')) {
		ddi.addEventListener('click', (e) => {
			e.stopPropagation();
		});
	}
})
